import { Component, OnInit } from '@angular/core';
import { Modal } from 'node_modules/bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { AccessService } from 'src/app/services/access.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-admuser-permission',
  templateUrl: './admuser-permission.component.html',
  styleUrl: './admuser-permission.component.scss'
})
export class AdmuserPermissionComponent implements OnInit {

  testModal: Modal | undefined;
  result: any;
  accesses: any;
  msg: Message = null;
  userId: string;
  accessId: string;
  /* Nivel Ficha */
  accessCreate: string;
  accessEdit: string;
  accessDelete: string;
  /* Nivel Section */
  createSection: string;
  editSection: string;
  deleteSection: string;
  /* Nivel Subsection */
  createSubsection: string;
  editSubsection: string;
  deleteSubsection: string;
  /* Nivel Graphic */
  createGraphic: string;
  editGraphic: string;
  deleteGraphic: string;
  /* Nivel Biblio */
  createBiblio: string;
  editBiblio: string;
  deleteBiblio: string;
  /* NivelPrimarySource */
  createSource: string;
  editSource: string;
  deleteSource: string;
  /**Nuevos permisos para botones */
  createReportT: string;
  createReportS: string;
  createDoc: string;
  createGD: string;
  createGI: string;
  createText: string;

  porcent: number;

  constructor(
    private accessService: AccessService,
    private activedRoute: ActivatedRoute,
    private usersService: UsersService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.getListAccess();
    this.getListModuls();
    this.createForm();
  }

  /* obtenemos la lista de modulos a los que se tiene acceso por usuario  */
  getListAccess() {
    const params = this.activedRoute.snapshot.params;
    if (params['id']) {
      this.accessService.getAccess(params['id']).subscribe({
        next: res => {
          this.result = res['data'];
          this.accesses = this.result[0].accesses;
          this.getOneUser();
        },
        error: err => console.error(err)
      });
    }
  }

  /* Traer datos de usuario al que se habilita o deshabilita los accesos */
  namePerson = {}
  getOneUser() {
    const params = this.activedRoute.snapshot.params;
    if (params['id']) {
      this.usersService.getNameOnePerson(params['id']).subscribe({
        next: res => {
          this.namePerson['name'] = res['data']['person'].name;
          this.namePerson['lastname'] = res['data']['person'].lastname;
        },
        error: err => console.error(err)
      });
    }
  }

  moduls = {}
  formAcs: FormGroup;
  formData: any

  createForm() {
    this.formAcs = this.fb.group({
      userId: this.activedRoute.snapshot.params['id'],
      accessId: [null, Validators.required],
      create: [false],
      edit: [false],
      del: [false]
    })
  }

  /* guardamos el modulo al que se da acceso */
  saveModul() {
    this.formData = this.formAcs.value
    this.submitted = true;

    if (this.formAcs.invalid) {
      return;
    } else {
      this.accessService.createModul(this.formData).subscribe({
        next: res => {
          this.getListAccess();
          this.modulstemp = [];
          this.array = [];
          this.getListModuls();
          this.createForm();
          this.submitted = false;
        },
        error: err => {
          console.log(err['msg']);
        }
      });
    }

  }


  /*hace un contraste entre el total de modulos existentes en la tabla access y los accesos a modulo que tiene el usuario
    seleccionado, el resultado son los accesos a modulo que aun no se les ha asignado*/

  array = [];
  bandCB = 0;
  modulstemp: any = [];
  getListModuls() {

    this.accessService.getModuls().subscribe({
      next: (res = Response) => {

        for (var i = 0; i < res['data'].length; i++) {

          var igual = false;

          for (var j = 0; j < this.accesses.length && !igual; j++) {

            if (res['data'][i]['modulo'] == this.accesses[j]['modulo'])

              igual = true;
          }

          if (!igual) this.array.push(res['data'][i]);
        }

        if (this.array.length === 0) {
          this.bandCB = 1;
        } else {
          this.modulstemp = this.array;
        }
      },
      error: err => {
        console.error(err)
      }
    });

  }

  /* Aqui guardamos las referencias   */
  seleccionados = {};
  /*   Metodo para el boton de guardar contenido del modal */
  save() {
    this.seleccionados['create'] = this.accessCreate;
    this.seleccionados['edit'] = this.accessEdit;
    this.seleccionados['del'] = this.accessDelete
    this.seleccionados['userId'] = this.userId;
    this.seleccionados['accessId'] = this.accessId;

    this.seleccionados['createSection'] = this.createSection;
    this.seleccionados['editSection'] = this.editSection;
    this.seleccionados['deleteSection'] = this.deleteSection;

    this.seleccionados['createSubsection'] = this.createSubsection;
    this.seleccionados['editSubsection'] = this.editSubsection;
    this.seleccionados['deleteSubsection'] = this.deleteSubsection;

    this.seleccionados['createGraphic'] = this.createGraphic;
    this.seleccionados['editGraphic'] = this.editGraphic;
    this.seleccionados['deleteGraphic'] = this.deleteGraphic;

    this.seleccionados['createBiblio'] = this.createBiblio;
    this.seleccionados['editBiblio'] = this.editBiblio;
    this.seleccionados['deleteBiblio'] = this.deleteBiblio;

    this.seleccionados['createSource'] = this.createSource;
    this.seleccionados['editSource'] = this.editSource;
    this.seleccionados['deleteSource'] = this.deleteSource;
    /**Nuevos permisos */
    this.seleccionados['createReportT'] = this.createReportT;
    this.seleccionados['createReportS'] = this.createReportS;
    this.seleccionados['createDoc'] = this.createDoc;

    this.seleccionados['createGD'] = this.createGD;
    this.seleccionados['createGI'] = this.createGI;
    this.seleccionados['createText'] = this.createText;
    const data = this.seleccionados;

    if (data) {
      this.accessService.updateModuleAccessForUser(data).subscribe({
        next: res => {
          this.getListAccess();
          this.testModal.toggle();
        },
        error: err => {
          console.error(err)
        }
      });
    }
  }

  sendId = {}

  /* Metodo para eliminar un registro de acceso a mmodulo */
  deleteOneModuleAccess(id1: string, id2: string, m1: string) {

    this.sendId['userId'] = id1;
    this.sendId['accessId'] = id2;

    const data = this.sendId;

    if (confirm('Esta seguro que desea quitar el acceso al modulo ' + m1)) {
      if (data) {
        this.accessService.deleteOneModuleAccess(data).subscribe({
          next: res => {
            this.modulstemp = [];
            this.array = [];
            this.getListAccess();
            this.getListModuls();
            this.bandCB = 0;
            this.createForm();
          },
          error: err => {
            console.error(err)
          }
        });
      }

    }


  }
  flagModal: boolean = false; //bandera para controlar los checkbox para actualidad y encuentro
  flagContentIncorporated: boolean = false; //bandera para controlar chekcbox de nuevas adiciones publicaciones, podcast, redes y foros del futuro 
  flagDocList: boolean = false; //bandera para controlar chekcbox de listado y documento metodologico
  flagGD: boolean = false; //bandera para controlar chekcbox grafico dispesion
  flagGI: boolean = false; //bandera para controlar chekcbox grafico interrelacion
  flagRT: boolean = false; //bandera para controlar chekcbox reporte territorial
  flagRS: boolean = false; //bandera para controlar chekcbox reporte sectorial  
  flagAdmUser: boolean = false; //bandera para controlar boton editar en usuarios,tematica y reporte
  /*   cargamos lo datos seleccionado para el modal */
  changeModel(item: any, itemModulo: any) {
    this.userId = item.userId;
    this.accessId = item.accessId;

    this.accessCreate = item.create;
    this.accessEdit = item.edit;
    this.accessDelete = item.del;

    this.createSection = item.createSection;
    this.editSection = item.editSection;
    this.deleteSection = item.deleteSection;

    this.createSubsection = item.createSubsection;
    this.editSubsection = item.editSubsection;
    this.deleteSubsection = item.deleteSubsection;

    this.createGraphic = item.createGraphic;
    this.editGraphic = item.editGraphic;
    this.deleteGraphic = item.deleteGraphic;

    this.createBiblio = item.createBiblio;
    this.editBiblio = item.editBiblio;
    this.deleteBiblio = item.deleteBiblio;

    this.createSource = item.createSource;
    this.editSource = item.editSource;
    this.deleteSource = item.deleteSource;

    this.createDoc = item.createDoc;
    this.createReportT = item.createReportT;
    this.createReportS = item.createReportS;

    this.createGD = item.createGD;
    this.createGI = item.createGI;
    this.createText = item.createText;
    if (itemModulo === 'actualidad' || itemModulo === 'encuentro') {
      this.flagModal = true;
    } else {
      this.flagModal = false;
    }
    if (itemModulo === 'usuarios' || itemModulo === 'reporte' || itemModulo === 'tematica' || itemModulo === 'comentarios' || itemModulo === 'suscripcion') {
      this.flagAdmUser = true;
    } else {
      this.flagAdmUser = false;
    }
    if (itemModulo === 'publicacion' || itemModulo === 'podcast' || itemModulo === 'redes' || itemModulo === 'foros') {
      this.flagContentIncorporated = true;
    } else {
      this.flagContentIncorporated = false;
    }
    if (itemModulo === 'tendencia' || itemModulo === 'riesgo' || itemModulo === 'oportunidad' || itemModulo === 'megatendencia' || itemModulo === 'escenario') {
      this.flagDocList = true;
    } else {
      this.flagDocList = false;
    }
    if (itemModulo === 'riesgo' || itemModulo === 'oportunidad') {
      this.flagGD = true;
    } else {
      this.flagGD = false;
    }
    if (itemModulo === 'megatendencia') {
      this.flagGI = true;
    } else {
      this.flagGI = false;
    }
    if (itemModulo === 'tendencia') {
      this.flagRS = true;
    } else {
      this.flagRS = false;
    }
    if (itemModulo === 'tendencia' || itemModulo === 'riesgo' || itemModulo === 'oportunidad') {
      this.flagRT = true;
    } else {
      this.flagRT = false;
    }
    this.open();
  }

  /*   Metodo para abrir el modal */
  open() {
    this.testModal = new bootstrap.Modal(document.getElementById('testModal'), {
      keyboard: false
    });
    this.testModal.show();
  }
  /* Bandera para controlar la validacion */
  submitted = false;
  /* revisar estado de imputs para validar  */
  get f() { return this.formAcs.controls }
}
